(function () {
  var modal = document.querySelector('[data-klaviyo-bis-modal]');
  var klaviyoKey = window.theme && window.theme.settings && window.theme.settings.klaviyoKey;
  if (!modal || !klaviyoKey) return;

  var form = modal.querySelector('[data-klaviyo-bis-form]');
  var title = modal.querySelector('[data-klaviyo-bis-product-title]');
  var picker = modal.querySelector('[data-klaviyo-bis-variant-picker]');
  var select = modal.querySelector('#klaviyo-bis-variant-select');
  var email = modal.querySelector('#klaviyo-bis-email');
  var error = modal.querySelector('[data-klaviyo-bis-error]');
  var success = modal.querySelector('[data-klaviyo-bis-success]');
  var submit = modal.querySelector('[data-klaviyo-bis-submit]');
  var underlay = document.querySelector('[data-underlay]');
  var variantId;

  function closeModal() {
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    modal.setAttribute('aria-hidden', 'true');
    if (window.ShopTheme && ShopTheme.Global) {
      ShopTheme.Global.toggleOverlay(false);
    } else if (underlay) {
      underlay.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-klaviyo-bis-open]');
    if (trigger) {
      var variants = JSON.parse(trigger.dataset.variants || '[]');
      title.textContent = trigger.dataset.productTitle || '';
      error.classList.add('hidden');
      success.classList.add('hidden');
      form.classList.remove('hidden');
      email.value = '';
      submit.disabled = false;
      select.replaceChildren();
      variants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        select.appendChild(option);
      });
      variantId = variants.length ? variants[0].id : null;
      picker.classList.toggle('hidden', variants.length < 2);
      modal.classList.remove('hidden');
      modal.classList.add('flex');
      modal.setAttribute('aria-hidden', 'false');
      if (window.ShopTheme && ShopTheme.Global) {
        ShopTheme.Global.toggleOverlay(true);
      } else if (underlay) {
        underlay.classList.remove('hidden');
        document.body.classList.add('overflow-hidden');
      }
      email.focus();
    }

    if (event.target.closest('[data-klaviyo-bis-close]') || event.target === modal || event.target === underlay) closeModal();
  });

  select.addEventListener('change', function () {
    variantId = this.value;
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (!variantId) return;
    error.classList.add('hidden');
    submit.disabled = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-02-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email.value.trim() } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Subscription request failed');
      form.classList.add('hidden');
      success.classList.remove('hidden');
    }).catch(function () {
      error.textContent = 'Something went wrong. Please try again.';
      error.classList.remove('hidden');
      submit.disabled = false;
    });
  });
})();
